import { DatasetRow } from '@/components/datasets/DatasetRow';
import type { DatasetSummaryDto } from '@/api/types';

interface DatasetListProps {
  datasets: DatasetSummaryDto[];
  onEdit: (dataset: DatasetSummaryDto) => void;
  onDelete: (dataset: DatasetSummaryDto) => void;
  busyDatasetId: string | null;
}

export function DatasetList({ datasets, onEdit, onDelete, busyDatasetId }: DatasetListProps) {
  if (datasets.length === 0) {
    return <p className="statusText statusTextMuted">No datasets uploaded yet.</p>;
  }

  return (
    <div className="list">
      {datasets.map((dataset) => (
        <DatasetRow
          key={dataset.id}
          dataset={dataset}
          onEdit={() => onEdit(dataset)}
          onDelete={() => onDelete(dataset)}
          busy={busyDatasetId === dataset.id}
        />
      ))}
    </div>
  );
}
